package es.subastia.utils

import androidx.compose.runtime.Composable

@Composable
actual fun rememberShareAction(): ((String) -> Unit)? {
    return null
}
